import React from "react";
import { useState } from "react";
import { imageServerUrl, imageSizes } from "../../constants/config";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
interface ImageModalProps {
  images: any;
}
const ImageModal: React.FC<ImageModalProps> = ({ images }) => {
  const [count, setCount] = useState(0);
    const renderDirectionIcon = (direction: "left" | "right") => {
      if (direction === "left") {
        const LeftIcon = FaChevronLeft as any;
        return <LeftIcon />;
      }
      // For right direction, we can use the same icon but rotate it
      const RightIcon = FaChevronRight as any;
      return <RightIcon />;
    }
  return (
    <div className="modal-image-container">
      <img className="modal-image" src={`${imageServerUrl}/image/${imageSizes.large}/${images[count]?.ID}`} alt="car" />
      <div className="prev-button" onClick={() => setCount(count === 0 ? images.length - 1 : count - 1)}>
        {renderDirectionIcon("left")}
      </div>
      <div className="next-button" onClick={() => setCount(count === images.length - 1 ? 0 : count + 1)}>
         {renderDirectionIcon("right")}
      </div>
    </div>
  );
};

export default ImageModal;